import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { Section } from './ProposalEditor';
import { TemplateMenu } from './TemplateMenu';

export const PaletteEditor = ({ palette, setPalette }) => {
  const [hex, setHex] = useState('#C6B395');
  const [name, setName] = useState('');
  const [err, setErr] = useState('');

  const add = () => {
    const h = hex.trim().startsWith('#') ? hex.trim() : `#${hex.trim()}`;
    if (!/^#[0-9a-fA-F]{6}$/.test(h)) { setErr('Usa un código de 6 cifras, por ejemplo #C6B395'); return; }
    if (palette.length >= 6) return;
    setPalette([...palette, { hex: h, name }]); setName(''); setErr('');
  };

  return (
    <Section title="Paleta de color (máx. 6)" testid="proposal-palette-section"
      actions={<TemplateMenu kind="palette" label="Paletas guardadas" testid="tpl-palette"
        getData={palette.length ? () => ({ colors: palette }) : null}
        onApply={(d) => setPalette(d.colors)} />}>
      <div className="flex flex-wrap gap-4 mb-6">
        {palette.map((c, i) => (
          <div key={i} className="relative" data-testid={`palette-color-${i}`}>
            <div className="w-20 h-20 border border-stilo-ink/10" style={{ backgroundColor: c.hex }} />
            <p className="text-xs mt-1 text-stilo-ink">{c.name}</p>
            <p className="text-[10px] text-stilo-ink3 uppercase">{c.hex}</p>
            <button onClick={() => setPalette(palette.filter((_, j) => j !== i))} className="absolute -top-2 -right-2 bg-stilo-ink text-stilo-bg p-0.5" aria-label="Quitar color" data-testid={`palette-remove-${i}`}><X className="w-3 h-3" /></button>
          </div>
        ))}
      </div>
      {palette.length < 6 && (
        <div className="flex flex-wrap items-center gap-2">
          <input type="color" value={hex} onChange={e => setHex(e.target.value)} className="w-12 h-10 border border-stilo-ink/15 bg-stilo-bg" data-testid="palette-color-picker" />
          <input value={hex} onChange={e => setHex(e.target.value)} className="w-28 border border-stilo-ink/15 p-2 bg-stilo-bg text-sm uppercase" data-testid="palette-hex-input" />
          <input value={name} onChange={e => setName(e.target.value)} placeholder="Nombre (ej. Arena)" className="flex-1 min-w-[160px] border border-stilo-ink/15 p-2 bg-stilo-bg text-sm" data-testid="palette-name-input" />
          <button onClick={add} className="inline-flex items-center gap-2 px-4 py-2 border border-stilo-ink/15 text-sm hover:border-stilo-ink" data-testid="palette-add"><Plus className="w-4 h-4" /> Añadir color</button>
        </div>
      )}
      {err && <p className="text-xs text-stilo-terra mt-2" data-testid="palette-error">{err}</p>}
    </Section>
  );
};
